import React from 'react';
import { CheckCircleIcon, MessageSquareIcon } from 'lucide-react';
export function About() {
  const benefits = ['Uzman teknisyen kadrosu', 'Modern teşhis ekipmanları', 'Hızlı servis süresi', 'Uygun fiyat garantisi', 'Kaliteli yedek parça', 'Müşteri memnuniyeti odaklı hizmet'];
  return <section id="hakkimizda" className="py-16" data-id="element-12">
      <div className="container mx-auto px-4" data-id="element-13">
        <div className="text-center mb-12" data-id="element-14">
          <h2 className="text-3xl font-bold text-blue-900 mb-4" data-id="element-15">
            Neden Güven Dizel?
          </h2>
        </div>
        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-16">
          <div className="w-full lg:w-1/2" data-id="element-17">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3uWiMZY2GGX54ddNQWHwfT/IMG_0742.jpg" alt="Dizel motor tamiri" className="rounded-lg shadow-xl w-full h-auto" data-id="element-18" />
          </div>
          <div className="w-full lg:w-1/2" data-id="element-19">
            <p className="text-gray-600 mb-6" data-id="element-20">
              Güven Dizel olarak Adapazarı'nda uzun yıllardır dizel araç bakım
              ve onarım sektöründe hizmet vermekteyiz. Deneyimli ekibimiz ve
              modern ekipmanlarımızla her türlü dizel motor arızasına çözüm
              sunuyoruz.
            </p>
            <p className="text-gray-600 mb-6" data-id="element-21">
              Müşteri memnuniyetini her zaman ön planda tutarak, kaliteli hizmet
              anlayışımızla bölgede güvenilir bir isim haline geldik. Adapazarı
              ve çevresinde hızlı servis sağlayarak, acil durumlarda da
              yanınızda oluyoruz.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-8" data-id="element-22">
              {benefits.map((benefit, index) => <div key={index} className="flex items-center" data-id="element-23">
                  <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2" data-id="element-24" />
                  <span className="text-gray-700" data-id="element-25">{benefit}</span>
                </div>)}
            </div>
            <a href="https://wa.me/905322847563" target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-green-600 text-white font-bold px-6 py-3 rounded-md hover:bg-green-700 transition" data-id="element-26">
              <MessageSquareIcon className="w-5 h-5 mr-2" data-id="element-27" />
              WhatsApp'dan iletişime geçin
            </a>
          </div>
        </div>
      </div>
    </section>;
}